var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',{staticClass:"row-alert",class:{ 'row-alert--above-row': _vm.aboveRow }},[_c('form-alert',{key:_vm.alertKey,attrs:{"message":_vm.message,"type":_vm.type,"scroll-on-mount":"","flush":""},on:{"dismiss":function($event){return _vm.$emit('dismiss')}}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69f28bea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RowAlert.vue
// module id = 1153
// module chunks = 0 2 6 8